import React from 'react';

/**
 * Standardized Dropdown Menu Item Component
 * @param {Object} props - Menu item properties
 * @param {React.ReactNode} props.children - Menu item content
 * @param {Function} props.onClick - Click handler
 * @param {string} props.variant - Variant: 'default', 'danger', 'warning', 'success'
 * @param {boolean} props.disabled - Whether item is disabled
 * @param {string} props.className - Additional CSS classes
 */
const DropdownMenuItem = ({
    children,
    onClick,
    variant = 'default',
    disabled = false,
    className = ''
}) => {
    const variantClasses = {
        default: 'text-gray-700 dark:text-[#c9d1d9] hover:bg-gray-100 dark:hover:bg-[#1c2128]',
        danger: 'text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/30',
        warning: 'text-orange-600 dark:text-orange-400 hover:bg-orange-50 dark:hover:bg-orange-950/30',
        success: 'text-green-600 dark:text-green-400 hover:bg-green-50 dark:hover:bg-green-950/30'
    };

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick && !disabled) {
            onClick(e);
        }
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            onMouseDown={(e) => {
                // Also handle mousedown to ensure it fires before click-outside handler
                e.stopPropagation();
            }}
            disabled={disabled}
            className={`block w-full text-left px-4 py-2 text-sm font-medium transition-colors duration-150 ${variantClasses[variant]} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
        >
            {children}
        </button>
    );
};

export default DropdownMenuItem;

